// ─── ErrorBoundary.js ─────────────────────────────────────────────────────────
// Catches React component crashes and shows a recovery UI instead of
// blanking the entire app. Wrap around major screen components.

import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) this.props.onReset();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="eb-container">
          <div className="eb-card">
            <div className="eb-icon">⚠️</div>
            <h2 className="eb-title">Something went wrong</h2>
            <p className="eb-message">
              {this.props.fallbackMessage || 'This section encountered an error. Your data is safe — try going back or reloading.'}
            </p>
            {this.state.error?.message && (
              <details className="eb-details">
                <summary>Technical details</summary>
                <code className="eb-code">{this.state.error.message}</code>
              </details>
            )}
            <div className="eb-actions">
              {this.props.onReset && (
                <button className="eb-btn eb-btn-primary" onClick={this.handleReset}>
                  ← Go Back
                </button>
              )}
              <button className="eb-btn eb-btn-secondary" onClick={() => window.location.reload()}>
                🔄 Reload App
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
